import {
    React,Component,BootstrapTable,
    paginationFactory,Button, ButtonToolbar, Card, 
    Form, Col, Row, axios, Container, Banner, Typeahead, TimePicker,
    cellEditFactory, Type, moment, NavLink, Alert, AppConfiguration,
    NoserLoading, Noser, sizePerPageRenderer, DatePicker, Redirect,Accordion,
    Tabs, Tab, Modal
} 
from '../../noser-hris-component';
import FileUpload from './Modal/FileUpload';
class PayfileMonitoring extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isloading: false,
            isshow: false,
            alerttype: "",
            message: "",
            color: "",
            fade: true,
            openModal: false,
            disableBtn: true,
            
            payrollGRID:[],
            clientDDL:[],
            periodDDL:[],
            paycardDDL:[],
            clientId:"",
            periodId:"",
            bdoBatchNo:"",
            mlBatchNo:"",
            mbBatchNo:"",
            palawanBatchNo:"",
            ubBatchNo:"",
            lbBatchNo:"",
            gcashBatchNo:"",

            showModal: false,
            selectedUploadRow: null,
            fileName: null,
            paycardtypeId:""
        };
    }

    componentDidMount() {
        this.state.userinfo = JSON.parse(sessionStorage.getItem("userData"))
        this.GetClients();
    }
    handleModalShow = (e) =>{
        this.setState({openModal:true})
        let obj = {
            "clientId" : this.state.clientId,
            "periodId" : this.state.periodId,
            "paycardtypeId" : e.payrollTypeId
        }
        this.child.initialize(obj)
    }
    handleModalClose = (e) =>{
        this.setState({openModal:false})
        this.handleSearch()
    }
    GetClients = async() =>{
        this.setState({isloading:true})
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
        }
        axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Client/GetClientList", params)
        .then(res => {
            this.setState({
                clientDDL:res.data.clients ? res.data.clients:[], isloading:false
            })
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
        this.GetPayCardTypes()
    }
    GetPayCardTypes = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetPayCardTypes",  params)
        .then(res => {
            const data = res.data;
            this.setState({paycardDDL:data.payCardTypes,isloading:false });
        })
    }
    GetPayPeriods = async(clientId,isSpecial) => {
        this.setState({isloading:true})
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   clientId,
            "UserId"        :   this.state.userinfo.userId,
            "EmployeeId"    :   "",
            "IsProcessed"   :   "1"
         };
         let api = ""
        if(isSpecial==="0"){
            api = "Timekeeping/GetPayrollPeriods"
        }
        else{
            api = "Timekeeping/GetSpecialPayrollPeriods"
        }
        
        await axios
             .post(
                AppConfiguration.Setting().noserapiendpoint + api,  params
             )
             .then(res => {
                const data = res.data;
                console.log(data)
                this.setState({
                    periodDDL:data.payrollPeriods,isloading:false 
                })
             })
    }
    handleSearch = async() => {
        
        if(this.state.clientId===""){
            this.setState({
                isloading       :   false,
                alerttype       :   "Danger!",
                isshow          :   true,
                color           :   "danger",
                message         :   "Please select client.",
                fade            :   true
            });
            return
        }

        if(this.state.periodId===""){
            this.setState({
                isloading       :   false,
                alerttype       :   "Danger!",
                isshow          :   true,
                color           :   "danger",
                message         :   "Please select period or cut off.",
                fade            :   true
            });
            return
        }

        this.setState({ isloading: true });
        const getParams = {
            IpAddress: "0.0.0.0",
            ClientId: this.state.clientId,
            UserId: this.state.userinfo.userId,
            PayPeriodId: this.state.periodId,
        };
    
        axios.post(AppConfiguration.Setting().noserapiendpoint + "Accounting/GetMonitoringPayrollFiles", getParams)
            .then(res => {
                const data = res.data;
                this.setState({payrollGRID: data.payrollFiles,isloading: false});
            })
            .catch(error => {
                this.setState({
                    isloading: false,
                    alerttype: "Error!",
                    isshow: true,
                    color: "danger",
                    message: "An error occurred while processing your request: " + error.message,
                    fade: true
                });
            });
    };
    
    downloadHandleClick = async(row) => {
        this.state.fileName        =   row.fileName
        this.state.payrollTypeId   =   row.payrollTypeId

        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   row.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "PayrollTypeId" :   row.payrollTypeId,
            "FileName"      :   row.fileName
        }
        console.log(params)
        await axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Accounting/DownloadPayrollFile", params,{'responseType': 'blob'})
        .then(res => {
            
            console.log(res)
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', row.fileName);
            document.body.appendChild(link);
            link.click();
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
    };
    
    handleClear = () => {
        this.setState({
            selectedClient: [],
            selectedPayPeriod: [],
            searchReference: '',
            searchpayFileID: '',
            filteredData: this.state.data
        });
    };
    
    handleTypeAheadChanged = name => e =>{
        console.log(name)
        
        if(e.length === 0) {
            this.setState({[name]:""})
            return
        }

        if(name==="clientId"){
            this.setState({[name]:e[0].id})
            this.GetPayPeriods(e[0].id,e[0].isSpecial)
        }
        else if(name==="periodId"){
            this.setState({[name]:e[0].periodId})
        }
        else{
            this.setState({[name]:e[0].id})
        }
    }
    handleTextChanged = (e) =>{
        this.setState({[e.target.name]: e.target.value})
    }
    render() {
        const parentColumn = [
            {
                dataField: 'client',
                text: 'Client',
                editable: false,
                style: { textAlign: 'left'},
                className: 'no-text-transform',
                headerStyle: () => {
                    return { textAlign: 'center', width: "30%"};
                },
            },
            {
                // dataField: 'payFileId',
                dataField: 'paycardType',
                text: 'Paycard Type',
                editable: false,
                sort: true,
                style: { textAlign: 'center'},
                headerStyle: () => {
                    return { textAlign: 'center', width: "10%"};
                },
            },
            {
                dataField: 'payPeriod',
                text: 'Payroll Period',
                editable: false,
                style: { textAlign: 'center'},
                headerStyle: () => {
                    return { textAlign: 'center', width: "10%"};
                },
            },
            {
                dataField: 'totalTxn',
                text: '# of Member',
                editable: false,
                style: { textAlign: 'center'},
                headerStyle: () => {
                    return { textAlign: 'center', width: "10%"};
                },
            },
            {
                dataField: 'totalTxnAmount',
                text: 'Total Amount',
                editable: false,
                style: { textAlign: 'right'},
                headerStyle: () => {
                    return { textAlign: 'center', width: "10%"};
                },
                // formatter: (cell) => {
                //     return cell.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                // }
            },
            {
                dataField: 'referenceNumber',
                text: 'Reference',
                editable: false,
                style: { textAlign: 'center'},
                headerStyle: () => {
                    return { textAlign: 'center', width: "20%"};
                },
            },
            {
                dataField: 'returnFile',
                text: 'Return File',
                editable: false,
                style: { textAlign: 'center', fontSize: "11px" },
                headerStyle: () => {
                    return { textAlign: 'center', width: "10%"};
                },
                formatter: (cell, row) => {
                    if(row.payrollTypeId==="2" || 
                        row.payrollTypeId==="6" ||
                        row.payrollTypeId==="14" ||
                        row.payrollTypeId==="16"){
                            return (
                                <Button style={{paddingTop:'0',paddingBottom:'0',marginLeft:'-10px',fontSize:'10px'}}
                                        variant="link" onClick={e => this.handleModalShow(row)}
                                >UPLOAD</Button>
                            );
                        }
                }
            },
            {
                dataField: 'action',
                text: 'Action',
                editable: false,
                style: { textAlign: 'center', fontSize: "11px" },
                headerStyle: () => {
                    return { textAlign: 'center', width: "10%", backgroundColor: 'green', color: 'white', fontSize: "11px" };
                },
                formatter: (cell, row) => {
                    return (
                        // <div style={{ textAlign: "center" }}>
                        //     <OverlayTrigger
                        //         placement="top"
                        //         overlay={
                        //             <Tooltip id={`tooltip-top`} style={{ fontSize: "12px" }}>
                        //                 Download
                        //             </Tooltip>
                        //         }
                        //     >
                        //         <span style={{ marginRight: "10px" }}>
                        //             <a href='#' onClick={e => this.downloadHandleClick(row)}>Download</a>
                        //         </span>
                        //     </OverlayTrigger>
                        // </div>
                        <Button style={{paddingTop:'0',paddingBottom:'0',marginLeft:'-10px',fontSize:'10px'}}
                                variant="link" onClick={e => this.downloadHandleClick(row)}
                        >Download</Button>
                    );
                }
            }
        ];

        const parentDetailsColumn = [
            {
                dataField: 'memberName',
                text: 'Employee Name',
                editable: false,
                style: { textAlign: 'left'},
                headerStyle: () => {
                    return { textAlign: 'center', width: "25%"};
                },
            },
            {
                dataField: 'senderName',
                text: 'Sender',
                editable: false,
                style: { textAlign: 'center'},
                headerStyle: () => {
                    return { textAlign: 'center', width: "20%"};
                },
            },
            {
                dataField: 'payCardNumber',
                text: 'Paycard',
                editable: false,
                style: { textAlign: 'center'},
                headerStyle: () => {
                    return { textAlign: 'center', width: "20%"};
                },
            },
            {
                dataField: 'amount',
                text: 'Amount',
                editable: false,
                style: { textAlign: 'right'},
                headerStyle: () => {
                    return { textAlign: 'center', width: "10%"};
                },
                // formatter: (cell) => {
                //     return cell.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                // }
            },
            {
                dataField: 'status',
                text: 'Status',
                editable: false,
                style: { textAlign: 'center'},
                headerStyle: () => {
                    return { textAlign: 'center', width: "10%"};
                },
            },
            {
                dataField: 'remarks',
                text: 'Remarks',
                editable: false,
                style: { textAlign: 'center'},
                headerStyle: () => {
                    return { textAlign: 'center', width: "15%"};
                },
            }
        ];
        const expandRowDetails = {
            onlyOneExpanding: true,
            renderer: row => 
            (
                <BootstrapTable
                    keyField = "id"
                    data = { row.payrollFileDetails }
                    columns = { parentDetailsColumn }
                    rowClasses="noser-table-row-class"
                    striped
                    hover
                    condensed
                    expandRow
                    wrapperClasses="table-responsive"
                    rowClasses="noser-table-row-class no-checkbox"
                    noDataIndication={ () => <div>No Payroll details.</div> }
                    selectRow={selectRow}
                /> 
            ),
            showExpandColumn: true,
        };
        const selectRow = {
            mode: 'checkbox',
            hideSelectAll: true,
            clickToExpand: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                
            }
        };
        return (
            <div>
                <Banner />
                <Container className="themed-container" fluid={true}>
                    <Card className="mt-5">
                        <Card.Header>Finance >> Payfile Monitoring</Card.Header>
                        <Card.Body>
                            <Form>
                                <Card>
                                    <Accordion defaultActiveKey="1">
                                        <div className="card-header-tab">
                                            <Accordion.Toggle as={Button} variant="link" eventKey="1" style={{color: "#FFFFFF"}}>
                                                SEARCH FILTER
                                            </Accordion.Toggle>
                                        </div>
                                        <Accordion.Collapse eventKey='1'>
                                            <Card.Body>
                                                <Form.Row>
                                                    <Form.Group as={Col} sm={6} controlId="formGridEmail">
                                                        <Typeahead
                                                            labelKey='name'
                                                            name='clientId'
                                                            onChange={this.handleTypeAheadChanged('clientId')}
                                                            options={this.state.clientDDL}
                                                            placeholder="Select Client"
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm={6} controlId="formGridEmail">
                                                        <Typeahead
                                                            labelKey='payPeriod'
                                                            name='periodId'
                                                            onChange={this.handleTypeAheadChanged('periodId')}
                                                            options={this.state.periodDDL}
                                                            placeholder="Select Pay Period"
                                                        />
                                                    </Form.Group>
                                                </Form.Row>

                                                <Form.Row>
                                                    <Form.Group as={Col} sm={6} controlId="formGridEmail">
                                                        <Form.Control
                                                            id="reference"
                                                            name='searchReference'
                                                            type="text" 
                                                            placeholder="Enter Reference"
                                                            autoComplete="off"
                                                            value={this.state.searchReference}
                                                            onChange={(e) => this.setState({ searchReference: e.target.value })}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm={6} controlId="formGridEmail">
                                                        <Typeahead
                                                            labelKey='name'
                                                            id='paycardtypeId'
                                                            name='paycardtypeId'
                                                            onChange={this.handleTypeAheadChanged('paycardtypeId')}
                                                            options={this.state.paycardDDL}
                                                            placeholder="Select Pay Card"
                                                        />
                                                        {/* <Form.Control
                                                            id="paycardType"
                                                            name='searchpayFileID'
                                                            type="text" 
                                                            placeholder="Enter Paycard Type"
                                                            autoComplete="off"
                                                            value={this.state.searchpayFileID}
                                                            onChange={(e) => this.setState({ searchpayFileID: e.target.value })}
                                                        /> */}
                                                    </Form.Group>
                                                </Form.Row>

                                                {/* <Form.Row>
                                                    <Form.Group as={Col} sm={2} controlId="formGridEmail">
                                                        <Form.Control 
                                                            type="text" 
                                                            autoComplete="off" 
                                                            name="bdoBatchNo"
                                                            value={this.state.bdoBatchNo}
                                                            placeholder="BDO Batch No"
                                                            onChange={this.handleTextChanged}
                                                            maxLength="3"
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm={2} controlId="formGridEmail">
                                                        <Form.Control 
                                                            type="text" 
                                                            autoComplete="off" 
                                                            name="mlBatchNo"
                                                            value={this.state.mlBatchNo}
                                                            placeholder="ML Batch No"
                                                            onChange={this.handleTextChanged}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm={2} controlId="formGridEmail">
                                                        <Form.Control 
                                                            type="text" 
                                                            autoComplete="off" 
                                                            name="mbBatchNo"
                                                            value={this.state.mbBatchNo}
                                                            placeholder="Metro Bank Batch No"
                                                            onChange={this.handleTextChanged}
                                                            maxLength="3"
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm={2} controlId="formGridEmail">
                                                        <Form.Control 
                                                            type="text" 
                                                            autoComplete="off" 
                                                            name="palawanBatchNo"
                                                            value={this.state.palawanBatchNo}
                                                            placeholder="PALAWAN Batch No"
                                                            onChange={this.handleTextChanged}
                                                            maxLength="3"
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm={2} controlId="formGridEmail">
                                                        <Form.Control 
                                                            type="text" 
                                                            autoComplete="off" 
                                                            name="ubBatchNo"
                                                            value={this.state.ubBatchNo}
                                                            placeholder="UB Batch No"
                                                            onChange={this.handleTextChanged}
                                                            maxLength="3"
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm={2} controlId="formGridEmail">
                                                        <Form.Control 
                                                            type="text" 
                                                            autoComplete="off" 
                                                            name="lbBatchNo"
                                                            value={this.state.lbBatchNo}
                                                            placeholder="LB Batch No"
                                                            onChange={this.handleTextChanged}
                                                            maxLength="3"
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} sm={2} controlId="formGridEmail">
                                                        <Form.Control 
                                                            type="text" 
                                                            autoComplete="off" 
                                                            name="gcashBatchNo"
                                                            value={this.state.gcashBatchNo}
                                                            placeholder="GCASH Batch No"
                                                            onChange={this.handleTextChanged}
                                                            maxLength="3"
                                                        />
                                                    </Form.Group>
                                                </Form.Row> */}
                                                <ButtonToolbar className="mt-4">
                                                    <Button 
                                                        name='searchPayfileRecord'
                                                        variant="primary" 
                                                        className="ml-auto noser-button-mr1"
                                                        onClick={this.handleSearch} >
                                                        Search
                                                    </Button>
                                                    <Button 
                                                        name='clearSearchFields'
                                                        variant="success" 
                                                        className="noser-button" 
                                                        onClick={this.handleClear} >
                                                        CLEAR
                                                    </Button>
                                                </ButtonToolbar>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Accordion>
                                </Card>
                            </Form>
                            <div className="mt-3">
                            <div className="card-header-tab"></div>
                                <BootstrapTable
                                    striped
                                    hover
                                    condensed
                                    pagination={paginationFactory({ sizePerPageRenderer })}
                                    keyField="id"
                                    selectRow = { selectRow }
                                    data={this.state.payrollGRID}
                                    columns={parentColumn}
                                    noDataIndication={() => <div>No record found.</div>}
                                    //cellEdit={cellEditFactory({ mode: 'dbclick', blurToSave: true })}
                                    expandRow={ expandRowDetails }
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Container>
                <NoserLoading show={this.state.isloading} />
                <FileUpload 
                    show={this.state.openModal}
                    onHide={this.handleModalClose}
                    onRefModal={ref => (this.child = ref)}
                />
            </div>
        );
    }
}

export default PayfileMonitoring;